import type { ReactNode } from 'react';

/**
 * Per-engagement shell (C20-129).
 *
 * Reduced to a pass-through after the C20-129 sidebar/topbar parity fix.
 *
 * Pre-C20-129 this component:
 *   - Owned the per-engagement sub-nav (Overview / Contract / Health /
 *     Go-Live / Register / Documents / Chat / Snapshot / Audit /
 *     Methodology / Archive) as a left rail rendered BELOW the global
 *     topbar.
 *   - Rendered a placeholder posture chip + "Capture snapshot" /
 *     "Generate PDF" buttons in the page heading.
 *
 * After C20-129:
 *   - The sub-nav lives in the global sidebar's "Engagements" section.
 *     When an engagement is active, the sidebar inlines its sub-tree
 *     beneath the engagement row (matching prototype/shell.js →
 *     renderSidebar's `engagementNav` expanded branch).
 *   - The posture chip + capture/PDF actions live inside the engagement
 *     overview hero (`apps/web/src/routes/engagements/$engagementId/
 *     index.tsx` → `<EngagementHero />` + `<FactsStrip />`), which is
 *     the contract for the overview screen per the prototype. Other
 *     screens that need the same chip-and-actions strip should render
 *     their own scoped instance from `<PostureChip />` + the snapshot
 *     mutations — not a global header.
 *
 * The wrapper survives only to keep the file route boundary
 * (`apps/web/src/routes/engagements/$engagementId/route.tsx`) honoring
 * its existing import so we don't churn the routing layer in a UI fix.
 * A follow-up can fold this away by inlining `<Outlet />` directly in
 * the file route.
 */
export function EngagementShell({ children }: { children: ReactNode }) {
  return <div className="min-w-0 px-6 py-6">{children}</div>;
}
